import script from "./RegisterTrainingProspect.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterTrainingProspect.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterTrainingProspect.vue?vue&type=style&index=0&id=06b53de5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b53de5"]])

export default __exports__